import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import {
  Button,
  Chip,
  List,
  ListItem,
  ListItemText,
  ListItemButton,
} from "@mui/material";
import { formatMoney } from "../utils";
import { AddCircle } from "@mui/icons-material";
import { APIProduct, getAllProducts } from "../api/products";
import SplitPageView from "../components/SplitPageView";
import ProductDetailsPage from "./ProductDetailsPage";

function ProductListPage() {
  const [searchParams, setSearchParams] = useSearchParams();
  const id = searchParams.get("id");

  const [productsData, setProductsData] = useState<APIProduct[]>([]);
  const [search, setSearch] = useState("");

  useEffect(() => {
    getAllProducts().then((v) =>
      setProductsData([...v].sort((a, b) => a.title.localeCompare(b.title)))
    );
  }, [id]);

  const terms = search.toLowerCase().split(/\s+/).filter(Boolean);
  const visible = productsData.filter((p) =>
    terms.every((t) =>
      `${p.title} ${p.description}`.toLowerCase().includes(t)
    )
  );

  return (
    <SplitPageView
      selected={
        !!searchParams.get("id") ||
        !!searchParams.get("cid") ||
        !!searchParams.get("new")
      }
      pageTitle="Products"
      search={search}
      onSearchChange={setSearch}
      contentList={
        <List style={{ padding: "0px" }}>
          <ListItem>
            <Button
              component={Link}
              to="/products?new=1"
              variant="contained"
              startIcon={<AddCircle />}
              fullWidth
            >
              New Product
            </Button>
          </ListItem>
          {visible.map((product) => (
            <ListItemButton
              component={Link}
              to={`/products?id=${product.id}`}
              key={product.id}
            >
              <ListItemText
                primary={product.title || "Untitled product"}
                secondary={product.description}
                primaryTypographyProps={{ fontWeight: 600 }}
                secondaryTypographyProps={{ noWrap: true }}
                sx={{ minWidth: 0 }}
              />
              <div style={{ textAlign: "right", marginLeft: 12, flexShrink: 0 }}>
                <div style={{ fontWeight: 600 }}>
                  {formatMoney(product.price || 0)}
                </div>
                {!product.taxable && (
                  <Chip size="small" variant="outlined" label="No tax" />
                )}
              </div>
            </ListItemButton>
          ))}
          {visible.length === 0 && (
            <ListItem>
              <ListItemText
                secondary={search ? "No products match." : "No products yet."}
              />
            </ListItem>
          )}
        </List>
      }
      mainContent={<ProductDetailsPage id={id || undefined} />}
    />
  );
}

export default ProductListPage;
